/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgImportFromLive = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-import-from-live_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-import-from-live_svg__st0"
      d="M11 5.4V12h2V5.4l1.3 1.3 1.4-1.4L12 1.6 8.3 5.3l1.4 1.4z"
    />
    <path
      className="ico-import-from-live_svg__st0"
      d="M21.2 15c.5-.5.8-1.2.8-2v-2c0-1.7-1.3-3-3-3h-4v2h4c.6 0 1 .4 1 1v2c0 .5-.4 1-1 1H5c-.6 0-1-.5-1-1v-2c0-.6.4-1 1-1h4V8H5c-1.7 0-3 1.3-3 3v2c0 .8.3 1.5.8 2-.5.5-.8 1.2-.8 2v2c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-2c0-.8-.3-1.5-.8-2zM20 19c0 .6-.5 1-1 1H5c-.6 0-1-.4-1-1v-2c0-.6.4-1 1-1h14c.5 0 1 .5 1 1v2z"
    />
  </Icon>
);
export { SvgImportFromLive as ImportFromLive };
